var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColorMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92525 34.6757L8.7 34.6757C8.76833 34.6673 8.84571 34.666 8.92525 34.6757Z",
    fill: "url(#paint0_linear_2965_149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37928 -8.7723e-07C1.06524 -8.20486e-07 -1.80022e-06 1.06524 -1.72853e-06 2.37928L-9.62573e-08 32.2964C-2.45635e-08 33.6105 1.06524 34.6757 2.37928 34.6757L5.85 34.6757L8.7 34.6757C8.76833 34.6673 8.84571 34.666 8.92525 34.6757C9.31135 34.7227 9.7485 35.0264 9.45 36.0094C9.36112 36.3021 9.25469 36.6352 9.14226 36.9871C8.68545 38.417 8.25 39.7141 8.25 40.8996C8.25 41.5784 8.55381 42.5268 9.75 41.6405C10.95 40.7514 17.4 36.0094 18.15 35.713C18.2896 35.6579 18.4084 35.5873 18.5402 35.509C19.1169 35.1665 19.9433 34.6757 23.85 34.6757L36.6207 34.6757C37.9348 34.6757 39 33.6105 39 32.2964L39 2.37929C39 1.06524 37.9348 -2.41262e-06 36.6207 -2.35588e-06L2.37928 -8.7723e-07Z",
    fill: "url(#paint1_linear_2965_149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.08 18.2744L15.987 18.1499V26.315C15.987 26.7714 15.882 27.1063 15.672 27.3227C15.462 27.539 15.096 27.6487 14.571 27.6487H12.213C11.709 27.6487 11.349 27.539 11.13 27.3227C10.911 27.1063 10.8 26.7685 10.8 26.315V7.90428C10.8 7.45083 10.911 7.10703 11.13 6.87882C11.349 6.65062 11.712 6.53799 12.213 6.53799H14.571C15.096 6.53799 15.462 6.64765 15.672 6.86401C15.882 7.08036 15.987 7.42712 15.987 7.90428V15.9153L16.08 15.7908L22.806 6.94106C22.932 6.77509 23.061 6.66544 23.199 6.61505C23.334 6.56467 23.55 6.53799 23.844 6.53799H27.7081C28.0861 6.53799 28.2751 6.71285 28.2751 7.06554C28.2751 7.23151 28.212 7.39748 28.086 7.56345L20.6371 17.0326L28.3051 26.6262C28.4311 26.7714 28.494 26.9374 28.494 27.1241C28.494 27.4768 28.305 27.6517 27.927 27.6517H23.997C23.745 27.6517 23.553 27.625 23.415 27.5746C23.28 27.5242 23.148 27.4234 23.022 27.2812",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2965_149",
    x1: -0.00000185834,
    y1: 0,
    x2: 31.6828,
    y2: 38.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7B03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2965_149",
    x1: -0.00000185834,
    y1: 0,
    x2: 31.6828,
    y2: 38.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7B03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorMobile);
export default __webpack_public_path__ + "static/media/logo_color_mobile.847a293039954df0e5bae5d9c57a5d58.svg";
export { ForwardRef as ReactComponent };